import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import showText from '@/directives/showText';
import lazyLoading from '@/directives/lazyLoading';
import parallax from '@/directives/parallax';
import simpleParallax from '@/directives/simpleParallax';
import parallaxText from '@/directives/parallaxText';
import scaleHover from '@/directives/scaleHover';

// create a new event hub
Vue.prototype.$eventHub = new Vue();

// directive
Vue.directive('show-text', showText);
Vue.directive('lazy-loading', lazyLoading);
Vue.directive('parallax', parallax);
Vue.directive('parallax-text', parallaxText);
Vue.directive('simple-parallax', simpleParallax);

Vue.directive('hover-scale-mouse', scaleHover);

// config
Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
